"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultConfigs = void 0;
exports.DefaultConfigs = {
    showTime: true,
    showLevelLabel: true,
    withStyles: true,
    store: "none",
    debug: false,
    styles: {
        Critical: {
            color: "white",
            backgroundColor: "#7f0000",
        },
        Error: {
            backgroundColor: "#b71c1c",
            color: "white",
        },
        Warn: {
            backgroundColor: "#fdd835",
            color: "black",
        },
        Info: {
            backgroundColor: "#2e7d32",
            color: "white",
        },
        Debug: {
            backgroundColor: "#3d5afe",
            color: "white",
        },
    },
};
